import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Destination } from '../../../models/quotation-model/catalogs/destination.model';
import { CommonFilterRequest, CommonResult } from '../../../models/quotation-model/customer.model';
import { environment } from '../../../../../environments/environment';
import {
  QuoterDestination,
  QuoterDestinationPaged,
} from '../../../models/quotation-model/catalogs/quoterConfig/quoter-destination.model';

@Injectable({
  providedIn: 'root',
})
export class DestinationService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getDestinations(): Observable<Destination[]> {
    return this.http.get<Destination[]>(this.URL_API + '/Product');
  }

  getDestinationsToBrand(): Observable<Destination[]> {
    return this.http.get<Destination[]>(this.URL_API + '/Product/GetProductsToBrand');
  }

  getDestinationsToDealer(dealerId: number): Observable<Destination[]> {
    return this.http.get<Destination[]>(
      this.URL_API + '/Product/GetProductsToBrand?dealerId=' + dealerId,
    );
  }

  getPagedDestinations(filters: CommonFilterRequest): Observable<QuoterDestinationPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '');
    return this.http.get<QuoterDestinationPaged>(
      this.URL_API + '/Product/GetPagedProducts',
      { params },
    );
  }
  upsertQuoterDestination(upsertDestination: QuoterDestination) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Product/UpsertProduct',
      upsertDestination,
    );
  }
}
